module.exports = __webpack_public_path__ + "img/JourneySelect1Annotated.c48f3f82.jpg";